import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form, ModalItem, FormItem, ButtonItem,
    InputItem, InputNumberItem, DatePickerItem, ErrorItem,
    TablaEditor
} from "../../../../Components/Items";
import moment from "moment";

class EditarTabla extends Component {
    formRef = React.createRef();

    state = {
        loading: false,
        visible: this.props.visible,
        columnas: [],
        filas: [],
    };

    componentDidUpdate(prevProps) {
        if (prevProps.visible !== this.props.visible) {
            this.setState({ visible: this.props.visible });
            if (this.props.visible && this.props.tablaId) {
                this.formRef.current && this.formRef.current.resetFields();
                this.setState({ columnas: [], filas: [] });
                this.consultarDatosTabla(this.props.tablaId);
            }
        }
    }

    onFinishFailed(e) { ErrorItem(e); }

    consultarDatosTabla(id) {
        this.setState({ loading: true });
        axios
            .post("tablas/datosTabla", { tablaId: id, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    message.error("No se encontraron los datos de la tabla");
                } else {
                    const { nombre, nombreFormula, descripcion, ejercicio, fechaInicioVigencia, fechaFinVigencia, columnas, filas } = res.data.data;

                    const filasConKey = (filas || []).map((f, i) => ({ ...f, key: i }));
                    this.setState({ columnas: columnas || [], filas: filasConKey });

                    this.formRef.current && this.formRef.current.setFieldsValue({
                        nombre, nombreFormula, descripcion, ejercicio,
                        fechaInicioVigencia: fechaInicioVigencia ? moment(fechaInicioVigencia) : undefined,
                        fechaFinVigencia: fechaFinVigencia ? moment(fechaFinVigencia) : undefined,
                    });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error al comunicarse con el servidor");
            });
    }

    onEditorChange({ columnas, filas }) {
        this.setState({ columnas, filas });
    }

    onFinish(values) {
        if (this.state.columnas.length === 0) return message.info("La tabla debe tener al menos una columna");

        const filas = this.state.filas.map(({ key, ...f }) => f);

        this.setState({ loading: true });
        axios
            .post(
                "tablas/editarTabla",
                { ...values, columnas: this.state.columnas, filas, tablaId: this.props.tablaId, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Tabla actualizada exitosamente");
                    this.cerrarModal();
                } else {
                    message.error("No se pudo actualizar la tabla");
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error al comunicarse con el servidor");
            });
    }

    cerrarModal = () => {
        this.props.cerrarEditarTabla();
        if (this.formRef.current) this.formRef.current.resetFields();
        this.setState({ columnas: [], filas: [] });
    };

    render() {
        return (
            <ModalItem
                title="Editar Tabla"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarModal}
                width={1000}
            >
                <Form
                    ref={this.formRef}
                    name="modalEditarTabla"
                    layout
                    bottom={
                        <ButtonItem type="primary" htmlType="submit"
                            style={{ display: "block", margin: "0 0 0 auto" }}
                            loading={this.state.loading}>
                            Guardar
                        </ButtonItem>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <FormItem name="nombre" label="Nombre" required margin>
                        <InputItem placeholder="Ej: ISR 2024" />
                    </FormItem>

                    <FormItem name="nombreFormula" label="Nombre Fórmula" margin
                        tooltip="Sin espacios ni caracteres especiales. Ej: ISR_2024">
                        <InputItem
                            placeholder="Ej: ISR_2024"
                            style={{ fontFamily: "monospace" }}
                            onChange={(e) => {
                                const limpio = e.target.value.replace(/[^a-zA-Z0-9_]/g, "");
                                this.formRef.current.setFieldsValue({ nombreFormula: limpio });
                            }}
                        />
                    </FormItem>

                    <FormItem name="descripcion" label="Descripción" margin>
                        <InputItem placeholder="Descripción opcional" />
                    </FormItem>

                    <FormItem name="ejercicio" label="Ejercicio" margin>
                        <InputNumberItem placeholder="Ej. 2024" min={2000} max={2100} />
                    </FormItem>

                    <FormItem name="fechaInicioVigencia" label="Inicio de Vigencia" margin>
                        <DatePickerItem placeholder="Informativo" style={{ width: "100%" }} />
                    </FormItem>

                    <FormItem name="fechaFinVigencia" label="Fin de Vigencia" margin>
                        <DatePickerItem placeholder="Informativo" style={{ width: "100%" }} />
                    </FormItem>
                </Form>

                <div style={{ marginTop: 16 }}>
                    <TablaEditor
                        columnas={this.state.columnas}
                        filas={this.state.filas}
                        onChange={this.onEditorChange.bind(this)}
                    />
                </div>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EditarTabla);